import React from 'react'

const TextField = (props) => {
    const { htmlFor, id, type, label} = props

    return (
        <>
            <label htmlFor={htmlFor} className="text-sm font-medium text-gray-600 block mb-2">{label}</label>
            <input type={type} id={id} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:outline-none block w-full p-2.5 focus:ring-4 ring-indigo-300 transition duration-200"/>
        </>
    )
}

export default TextField
